import { render, staticRenderFns } from "./oneClickModify.vue?vue&type=template&id=10277727&scoped=true&"
import script from "./oneClickModify.vue?vue&type=script&lang=js&"
export * from "./oneClickModify.vue?vue&type=script&lang=js&"
import style0 from "./oneClickModify.vue?vue&type=style&index=0&id=10277727&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10277727",
  null
  
)

export default component.exports